import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class TopicAPI extends API {
	getByOrganSessionInstitution(
		organ,
		institutionR,
		institutionA,
		status,
		numberPage,
		recordsPage
	) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucion?organoId=${organ}&institucionR=${institutionR}&institucionA=${institutionA}&estatus=${status}&numeroDePagina=${numberPage}&registrosPorPagina=${recordsPage}`,
		    method: HTTP_METHODS.post_M,
			})
		);
	}
	getByOrganSessionEnlace(session) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesion_enlace?sesionId=${session}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	enviarNotificacionResponsable(id_resolucion, estatus) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/setEstatus/${id_resolucion}/${estatus}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByOrganSession(organ, session, status, numberPage, recordsPage) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesion?organoId=${organ}&sesionId=${session}&estatus=${status}&numeroDePagina=${numberPage}&registrosPorPagina=${recordsPage}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getByOrgan(organ) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/organo?organoId=${organ}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByOrganPredictiveResolution(organ, business, status, numberPage, recordsPage) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/predictivo?organoId=${organ}&asunto=${business}&estatus=${status}&numeroDePagina=${numberPage}&registrosPorPagina=${recordsPage}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getByResolution(resolution) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/detalle/${resolution}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getResolutionsBySessionId(organo) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/resoluciones-aceptadas?organoId=${organo}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	noitifyResponsableView(session) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/enviar-notificacion-responsable/${session}`,
				data: {},
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getResolutionsPoint(order) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener-por-orden-dia?ordenDia=${order}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getAlertResolutions(idUser) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener-porusuario-alerta/${idUser}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const topicAPI = new TopicAPI('/temas');
